module.exports = __webpack_public_path__ + "static/media/family-room.ebb76a07.svg";